export enum PostAuthCheckFailureReasons {
    PASSWORD_EXPIRED = 'Password Expired',
    NEW_PASSWORD_REQUIRED = 'New Password Required'
}